module.exports = __webpack_public_path__ + "img/laboratorio2_4-3_2048.7f40d4e1.jpg";